import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { newPlaceBooking } from "../../../utils/axios-requests";
import { BookingStrategyContext } from "./bookingStrategies";
import { buildUsers } from "./buildUsers.function";
import { runBookingWriteWithCancelConfirm } from "./runBookingWriteWithCancelConfirm.function";

export const placeBookingStrategy = (ctx: BookingStrategyContext) => {
  const users = buildUsers(ctx);

  const basePayload = {
    users,
    bookingType: ctx.inputs.bookingType as BookingType,
    locationInventoryId: ctx.inputs.selectedLocation,
    automatedSeating: ctx.inputs.automatedSeating,
    automatedSeatingObjects: ctx.inputs.automatedSeatingObjects,
    weekdays: ctx.inputs.weekdays,
    ...ctx.standardBookingInfo,
    ...ctx.standardBookingTimes
  };

  runBookingWriteWithCancelConfirm(
    confirmCancelExistingBookings =>
      newPlaceBooking({
        ...basePayload,
        ...(confirmCancelExistingBookings ? { confirmCancelExistingBookings: true } : {})
      }),
    {
      onSuccess: () => {
        ctx.onSuccess();
        ctx.conferenceBookingUsers(
          ctx.conferenceInputs,
          ctx.inputs,
          ctx.conferenceBooking,
          ctx.sub,
          ctx.timezoneMobileWorking,
          ctx.onError
        );
      },
      onError: ctx.onError,
      onCancelExistingConfirmationRequired: ctx.onCancelExistingConfirmationRequired
    }
  );
};
